<template>
  <div class="Journal-box" id="Journal">
    <div>
      <div class="Journal-top">
        <h1>{{ $t("Journal.title") }}</h1>
        <p>{{ $t("Journal.describe") }}</p>
      </div>
      <div class="Journal-view">
        <div
          class="Journal-item"
          v-for="(item, index) in JournalList"
          :key="index"
          @click="onDateils(item)"
        >
         <img :src="'./static/image/' + item.img" alt="" />
          <div>
            <p :style="item.status == 0 ? 'background: rgba(0,0,0,0.5);' : ''">
              {{ item.count }}
            </p>
            <p>{{ item.title }}</p>
            <p>{{ item.describe }}</p>
            <p>{{ item.more }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => {
    return {
      JournalList: [],
    };
  },
  computed: {
    list() {
      return this.$t("Journal.list");
    },
  },
  created() {
    this.intData()
  },
  methods: {
    intData() {
      //引用axios
      const lang = localStorage.getItem("lang");
      switch (lang) {
        case 'en':
          axios.get("/static/lang/en.json", {})
            .then(({ data }) => {
              console.log('获取到的json数据', data);
              this.JournalList = data.JournalList
            })
          break;
        case 'Czh':
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/Czh.json", {})
            .then(({ data }) => {
              console.log('获取到的json数据', data);
              this.JournalList = data.JournalList
            })

          break;

        default:
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/zh.json", {})
            .then(({ data }) => {
              console.log('获取到的json数据', data);
              this.JournalList = data.JournalList
            })

          break;
      }

    },
    onDateils(item) {
      window.scrollTo({ top: 0 });
      if (item.status == 1) {
          localStorage.setItem("details", JSON.stringify(item))
        this.$router.push({ path: "/Journal", query: { id: item.id } });
      } else {
        this.$router.push("/journalform");
      }
    },
  },
};
</script>


<style lang="less" scoped>
.Journal-box {
  width: 100%;
  background-color: #fff;
  padding: 60px 0;

  > div {
    width: 1280px;
    margin: auto;
  }

  .Journal-top {
    h1 {
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
    }
  }

  .Journal-view {
    display: flex;
    width: 1280px;
    height: 350px;
    // overflow: hidden;
    flex-wrap: wrap;
    margin: 40px 0;

    // overflow-x: scroll;
    // white-space: nowrap;
    .Journal-item {
      width: 390px;
      height: 330px;
      background: #0041f0;
      border-radius: 8px;
      margin-bottom: 40px;
      margin-right: 30px;
      cursor: pointer;
      position: relative;

      img {
        width: 390px;
        height: 330px;
        background: #0041f0;
        border-radius: 8px;
      }

      div {
        width: 330px;
        height: 170px;
        background: #ffffff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        position: absolute;
        right: -20px;
        bottom: -20px;
        padding: 20px;
        box-sizing: border-box;

        p:nth-child(1) {
          width: 60px;
          height: 22px;
          background: #ff5200;
          border-radius: 11px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
          text-align: center;
        }

        p:nth-child(2) {
          width: 280px;
          font-size: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 33px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin: 10px 0;
        }

        p:nth-child(3) {
          width: 280px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #616364;
          line-height: 33px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        p:nth-child(4) {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #0041f0;
          cursor: pointer;
        }

        p:nth-child(4):hover {
          text-decoration: underline;
        }
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .Journal-box {
    width: 100%;
    background-color: #fff;
    padding-top: 8rem;
    padding-top: 0px;

    > div {
      padding: 0 5rem;
      width: 98rem;
    }

    .Journal-top {
      h1 {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 7.2rem;
        margin-bottom: 2rem;
      }

      p {
        font-size: 3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 4.3rem;
      }
    }

    .Journal-view {
      display: flex;
      width: 98rem;
      height: 75rem;
      overflow-x: auto;
      flex-wrap: nowrap;
      margin: 40px 0;
      margin-bottom: 0;

      // overflow-x: scroll;
      // white-space: nowrap;
      .Journal-item {
        width: 76.4rem;
        height: 64.6rem;
        background: #0041f0;
        border-radius: 2rem;
        // margin-bottom: 40px;
        margin-right: 10rem;

        position: relative;

        img {
          width: 76.4rem;
          height: 64.6rem;
          background: #0041f0;
          border-radius: 2rem;
        }

        div {
          width: 65rem;
          height: 35rem;
          background: #ffffff;
          box-shadow: 0px 0px 3.3rem 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          position: absolute;
          right: -4rem;
          bottom: -4rem;
          padding: 4rem;
          box-sizing: border-box;

          p:nth-child(1) {
            width: 11.6rem;
            height: 4.4rem;
            background: #ff5200;
            border-radius: 2.2rem;
            font-size: 2.8rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 4.4rem;
            text-align: center;
          }

          p:nth-child(2) {
            width: 57rem;
            font-size: 4.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 6.3rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 1.5rem 0;
          }

          p:nth-child(3) {
            width: 57rem;
            font-size: 3.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #616364;
            line-height: 5rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          p:nth-child(4) {
            font-size: 3.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #0041f0;
            cursor: pointer;
            margin-top: 3.8rem;
          }

          p:nth-child(4):hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>